import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@aviary/components/Button";
import { l } from "@aviary/locales/i18n";

import * as styles from "./A11yMenu.styles";

const A11yMenu: FC = () => {
  const { t } = useTranslation("aviary");

  return (
    <nav aria-label={t(l.aviary.a11yMenu.AccessibleNavigation)} css={styles.a11yMenu}>
      <Button isText href="#main-content">
        {t(l.aviary.a11yMenu.SkipToMainContent)}
      </Button>
    </nav>
  );
};

export { A11yMenu };
